/* Little Perfections: storefront quantity controls. Checkout validation is separate. */
(() => {
  const selector = 'input[data-lp-min]';
  const valid = input => Number.isSafeInteger(Number(input.value)) && Number(input.value) >= Number(input.dataset.lpMin);
  const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:window.Shopify?.currency?.active || 'GBP'}).format(cents/100);
  function updateTotals() {
    document.querySelectorAll('[data-lp-order-summary]').forEach(summary => {
      const form=summary.closest('form'), input=form?.querySelector(selector);
      if(!input) return;
      const variants=JSON.parse(summary.dataset.lpVariants || '[]');
      const variant=variants.find(v=>String(v.id)===form.querySelector('[name="id"]')?.value);
      if(!variant || !valid(input)) {summary.textContent='Please enter a whole number of at least '+input.dataset.lpMin+' cards.';return;}
      const extra=form.querySelector('[name="single_upsell"][data-upsell="option"]:checked');
      const total=variant.price*Number(input.value)+Number(extra?.dataset.variantPrice || 0);
      summary.textContent=input.value+' cards × '+format(variant.price)+' each'+(extra?' + selected extra':'')+' — '+format(total)+' before delivery';
    });
  }
  function cartReady(form) {
    const invalid=[...form.querySelectorAll('input[name="updates[]"][data-lp-min]')].find(input=>!valid(input));
    if(!invalid) return true;
    invalid.setCustomValidity('Please order at least '+invalid.dataset.lpMin+' cards of this design, or remove it from your basket.');
    invalid.reportValidity(); invalid.focus(); return false;
  }
  function initialize() {
    document.querySelectorAll(selector).forEach(input=>{
      input.min=input.dataset.lpMin;input.step='1';input.inputMode='numeric';
      if(input.name==='updates[]'&&!input.parentElement.parentElement.parentElement.querySelector('[data-lp-cart-note]')) {
        const note=document.createElement('small');note.dataset.lpCartNote='';note.className='d-block small mt-2';note.textContent='Minimum '+input.dataset.lpMin+' per design. Use Remove to delete.';input.parentElement.parentElement.insertAdjacentElement('afterend',note);
      }
    }); updateTotals();
  }
  document.addEventListener('change',event=>{
    const input=event.target;
    if(input.matches?.(selector)) {
      input.setCustomValidity('');if(!valid(input))input.value=input.dataset.lpMin;
      if(input.name==='quantity') {
        const id=input.form?.querySelector('[name="id"]')?.value;
        document.querySelectorAll('input[name="quantity"][data-lp-min]').forEach(other=>{if(other.form?.querySelector('[name="id"]')?.value===id)other.value=input.value;});
      }
    } queueMicrotask(updateTotals);
  },true);
  document.addEventListener('input',event=>{if(event.target.matches?.(selector)){event.target.setCustomValidity('');updateTotals();}},true);
  document.addEventListener('submit',event=>{
    const form=event.target,qty=form.querySelector('input[name="quantity"][data-lp-min]');
    if(qty&&!valid(qty)) {event.preventDefault();event.stopImmediatePropagation();qty.setCustomValidity('Please enter at least '+qty.dataset.lpMin+' cards, in whole numbers.');qty.reportValidity();}
    else if(!cartReady(form)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('click',event=>{const checkout=event.target.closest?.('[name="checkout"], .btn-checkout');if(checkout?.form&&!cartReady(checkout.form)){event.preventDefault();event.stopImmediatePropagation();}},true);
  window.addEventListener('variantChange.ecomify.product',()=>queueMicrotask(updateTotals));
  window.addEventListener('updated.ecomify.cart',initialize);
  document.addEventListener('shopify:section:load',initialize);
  const originalAdd=window.onSubmitAtcForm;
  window.onSubmitAtcForm=function(form,event) {
    const qty=form.querySelector('input[name="quantity"][data-lp-min]');
    if(qty&&!valid(qty)) {event?.preventDefault();qty.setCustomValidity('Please enter at least '+qty.dataset.lpMin+' cards.');qty.reportValidity();return;}
    const card=form.closest('.product-item');
    const title=card?.querySelector('.product-item-title')?.textContent?.toLowerCase() || '';
    const link=card?.querySelector('.product-item-title a');
    if(!qty && title.includes('place card') && !/top-up|top up/.test(title) && link) {event?.preventDefault();window.location.assign(link.href);return;}
    return originalAdd.call(this,form,event);
  };
  initialize();
})();
